// Must match App.Api Properties/launchSettings.json applicationUrl (HTTPS port).
const local = {
    API: {
        AUTH: 'https://localhost:7094/api',
        DATA: 'https://localhost:7094/api'
    },
    CHAT: 'https://localhost:7094/chat'
}

const dev = {
    API: {
        AUTH: 'https://localhost:7094/api',
        DATA: 'https://localhost:7094/api'
    },
    CHAT: 'https://localhost:7094/chat'
}

const uat = {
    API: {
        AUTH: 'https://aserve-tms-api-uat.azurewebsites.net/api',
        DATA: 'https://aserve-tms-api-uat.azurewebsites.net/api'
    }, 
    CHAT: 'https://aserve-tms-api-uat.azurewebsites.net/chat'
}

const prod = {
    API: {
        AUTH: 'https://aserve-tms-api.azurewebsites.net/api',
        DATA: 'https://aserve-tms-api.azurewebsites.net/api'
    }, 
    CHAT: 'https://aserve-tms-api.azurewebsites.net/chat'
}

const config = process.env.REACT_APP_STAGE === 'prod' ? prod
    : process.env.REACT_APP_STAGE === 'uat' ? uat
        : process.env.REACT_APP_STAGE === 'dev' ? dev
            : local;

const API_URL = config.API.DATA;
const AUTH_URL = config.API.AUTH;

export { API_URL, AUTH_URL };
export default config;
